module.exports = __webpack_public_path__ + "static/media/sppu.ca467f21.png";